import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import cogoToast from 'cogo-toast';
import { connect } from 'react-redux';

import { ToolTipRatings } from '../../components';
import CheckAvailabilityForm from './CheckAvailabilityForm';

import createInvoice from '../../api/createInvoice';

import { useSelector } from '../../redux';
import { getGuideSearchQuery } from '../../redux/selectors';
import { onRequestGuide } from '@dom/app/src/actions/analytics';

import {
  getLocaleString,
} from '../../utils';
import { isGuideUnavailable } from './utils';

import { GUIDE_INSURANCE_COST } from '../../constants';

const TOAST_MESSAGE = 'Guide is not available on the dates you requested';
const TOAST_OPTIONS = {
  hideAfter: 0,
  position: 'bottom-right',
  onClick: hide => hide(),
  heading: 'Guide Is Unavailable'
};

function BannerInfo({ data, history, ratings, numberOfReviews, hasStarRatings, onRequestGuide }) {
  const [isUnavailable, setIsUnavailable] = useState(false);
  const [hasShownToast, setHasShownToast] = useState(null);

  const { id, name, livesIn, currency = 'USD', amount, experienceYears, upcomingTreks } = data;

  const { guideQuery: trekName, startDate, endDate, pax, numberOfDays } = useSelector(getGuideSearchQuery) || {};

  const totalCost = Number(numberOfDays) * Number(amount) + GUIDE_INSURANCE_COST || amount;
  // const priceBreakDown = `Price for ${numberOfDays || 1} Day${numberOfDays ? 's' : ''} is ${currency} ${getLocaleString(totalCost)}`;
  // const tooltipMessage = 'Includes Wages, Insurance, Food & Lodging only.';

  const getGuideInvoice = async () => {
    try {
      const data = {
        leadersOnly: {
          trekName,
          leaderId: id,
          startDate,
          endDate,
          numTrekkers: Number(pax),
        }
      };

      const { invoices } = await createInvoice(data);
      const invoice = invoices[0];

      onRequestGuide();
      goToPayment(invoice);

    } catch (e) {
      console.log(e);
    }

  };

  const goToPayment = invoiceId => history.push(`/payment?guideId=${id}&invoiceId=${invoiceId}`);

  if (upcomingTreks && !hasShownToast) {
    if (isGuideUnavailable(startDate, endDate, upcomingTreks)) {
      cogoToast.warn(TOAST_MESSAGE, TOAST_OPTIONS);
      setIsUnavailable(true);
    }
    setHasShownToast(true);
  }

  const RequestGuideButton = () => <Button color="yellow" size="sm" onClick={getGuideInvoice} disabled={isUnavailable}>Request Guide</Button>

  return (
    <Fragment>
      <div className="detail-head">
        <div className="left-wrap">
          <div className="detail">
            <h1 className="name">{name}</h1>
            <span>
              {hasStarRatings ? <ToolTipRatings ratings={ratings} /> : null}
              {numberOfReviews ? <span> ({numberOfReviews} Review{numberOfReviews > 1 ? 's)' : ')'}</span> : null}
            </span>
          </div>
          <ul>
            {livesIn && <li>Based In: {livesIn}</li>}
            {experienceYears && <li>Experience: {experienceYears} years</li>}
          </ul>
        </div>
        <div className="right-wrap">
          {numberOfDays ? <RequestGuideButton /> : <CheckAvailabilityForm />}
        </div>
        {/* <div className="guide-price">
        {amount && (
          <>
            <h5>{currency} {amount}/day</h5>
            {numberOfDays && <span className="brk">{priceBreakDown}</span>}
            <p style={{ color: '#4a4a4a', lineHeight: '12px', fontSize: '13px', margin: '0' }}>{tooltipMessage}</p>
            <p style={{ color: '#e91e63', fontSize: '0.8rem', marginBottom: '0' }}>Free Cancellation within 7 days</p>
          </>
        )}
      </div> */}
      </div>
      <ul className="verify-list">
        <li><i className="icon icon-hg-check-circle verified" /> Certified Guide</li>
        <li><i className="icon icon-hg-check-circle verified" /> Verified Email Address</li>
        <li><i className="icon icon-hg-check-circle verified" /> Verified Phone Number</li>
        <li><i className="icon icon-hg-check-circle verified" /> Verified Government Id</li>
      </ul>
    </Fragment>
  );
}

const mapStateToProps = ({ ratings, reviews }) => ({
  ratings: ratings.ratings,
  hasStarRatings: Object.keys(ratings.ratings || {}).length > 0,
  numberOfReviews: reviews.reviews.length,
});

const ConnectedBannerInfo = connect(mapStateToProps, { onRequestGuide })(BannerInfo);

export default withRouter(ConnectedBannerInfo);
